import { A_Error } from "@adaas/a-concept";



export class AreTokenizerError extends A_Error {

}